<template>
  <div v-loading.fullscreen.lock="fullscreenLoading" class="wlsqcl-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="处理状态">
              <el-select v-model="searchForm.type" style="width: 120px" filterable clearable @keyup.enter.native="Search">
                <el-option label="待处理" :value="1" />
                <el-option label="已处理" :value="2" />
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-table
              v-loading="loading"
              :data="tableData"
              stripe
              style="width: 100%"
            >
              <el-table-column
                label="申请单号"
                width="180"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.apply_order }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="经销商"
                width="120"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.all_name }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="申请时间"
                width="170"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.apply_time }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="申请人"
                width="120"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ scope.row.userName }}
                </template>
              </el-table-column>
              <el-table-column
                label="备注"
                min-width="180"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.remark!==null&&scope.row.remark!==''&&scope.row.remark!==undefined">{{ scope.row.remark }}</span>
                  <span v-if="scope.row.remark===null||scope.row.remark===''||scope.row.remark===undefined">N/A</span>
                </template>
              </el-table-column>
              <el-table-column
                label="处理状态"
                width="120"
                align="center"
                fixed="right"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.opertime!==null&&scope.row.opertime!==''&&scope.row.opertime!==undefined" :disable-transitions="true" size="mini">已处理</el-tag>
                  <el-tag v-if="scope.row.opertime===null||scope.row.opertime===''||scope.row.opertime===undefined" :disable-transitions="true" size="mini" type="warning">待处理</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                label="金额/元"
                fixed="right"
                width="120"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span style="font-weight: 500;color:#409EFF;">{{ scope.row.addprice }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="已收款/元"
                fixed="right"
                width="120"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.paidfor<scope.row.addprice" style="color:#f56c6c;font-weight: 500;">{{ scope.row.paidfor }}</span>
                  <span v-if="scope.row.paidfor>=scope.row.addprice" style="color:#409EFF;font-weight: 500;">{{ scope.row.paidfor }}</span>
                </template>
              </el-table-column>
              <el-table-column
                width="210"
                fixed="right"
                align="center"
                label="操作"
              >
                <template slot-scope="scope">
                  <el-button v-if="scope.row.opertime===null||scope.row.opertime===''||scope.row.opertime===undefined" icon="el-icon-finished" size="mini" @click="edit(scope.row.apply_id)">立即处理</el-button>
                  <el-button v-if="scope.row.opertime!==null&&scope.row.opertime!==''&&scope.row.opertime!==undefined" icon="el-icon-search" size="mini" @click="view(scope.row.apply_id)">查看详情</el-button>
                  <el-button v-if="scope.row.addprice>0" icon="el-icon-document" size="mini" @click="getCollectRecord(scope.row)">收款</el-button>
                  <el-button v-if="scope.row.addprice<=0" icon="el-icon-document" :disabled="true" size="mini">收款</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0"
              background
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTitle"
      :visible.sync="editVisible"
      width="950px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="editForm" v-loading="infoLoading" :model="editForm" :rules="editRules" label-width="80px" size="small">
        <div>
          <span style="color:#99a9bf;">申请单号：</span>
          <span>{{ editForm.manum }}</span>
          <span style="color:#99a9bf;margin-left:30px">经销商：</span>
          <span>{{ editForm.delinfo }}</span>
          <span style="color:#99a9bf;margin-left:30px">总价：</span>
          <span style="font-weight: 500;color:#409EFF">{{ editForm.addprice }}</span>
        </div>
        <div style="margin:10px 0">
          <span style="color:#99a9bf;">增加备注：</span>
          <span v-if="editForm.remark!==null&&editForm.remark!==''&&editForm.remark!==undefined">{{ editForm.remark }}</span>
          <span v-if="editForm.remark===null||editForm.remark===''||editForm.remark===undefined">N/A</span>
        </div>
        <div v-if="editForm.isnewbus===1" style="font-size: 13px;color:#f56c6c;margin-bottom: 10px">
          <i class="el-icon-info"></i> 申请提示：此次为新商申请，选取标配物料免费，超出标配数量则追加相应价格
        </div>
        <el-table
          ref="multipleTable"
          :data="materialList"
          size="small"
          border
          row-key="material_id"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
          tooltip-effect="dark"
          :header-cell-style="{background:'#F5F7FA'}"
          style="width: 100%;margin-bottom: 10px"
        >
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="50"
          >
          </el-table-column>
          <el-table-column
            property="material_name"
            align="left"
            label="物料名称"
            show-overflow-tooltip
            min-width="120"
          >
          </el-table-column>
          <el-table-column
            prop="img"
            align="center"
            label="图片"
            width="100"
          >
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.img"
                style="width: 80px; height: 80px"
                :src="scope.row.img"
                fit="contain"
                :preview-src-list="[scope.row.img]"
              >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column
            property="brandName"
            label="品牌"
            show-overflow-tooltip
            align="center"
            width="110"
          >
          </el-table-column>
          <el-table-column
            property="material_spce"
            label="规格"
            show-overflow-tooltip
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            align="center"
            label="标配数量"
            width="80"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.is_standard===1">{{ scope.row.standard }}</span>
              <el-tag v-if="scope.row.is_standard!==1" :disable-transitions="true" type="info" size="mini">非标配</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            property="price"
            label="单价/元"
            show-overflow-tooltip
            align="center"
            width="80"
          >
          </el-table-column>
          <el-table-column
            label="价格/元"
            align="center"
            width="90"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.addprice>0" style="font-weight: 500;color:#409EFF">{{ scope.row.addprice }}</span>
              <span v-if="scope.row.addprice<=0" style="font-weight: 500;color:#909399">0</span>
            </template>
          </el-table-column>
          <el-table-column
            label="数量"
            align="center"
            width="90"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.counts }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="isview===false"
            label="库存"
            align="center"
            width="90"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.instock>=scope.row.counts">{{ scope.row.instock }}</span>
              <span v-if="scope.row.instock<scope.row.counts" style="font-weight: 500;color:#f56c6c">{{ scope.row.instock }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="isview===true">
          <span style="color:#99a9bf;">处理人：</span>
          <span>{{ editForm.operName }}</span>
          <span style="color:#99a9bf;margin-left:30px">处理时间：</span>
          <span>{{ editForm.opertime }}</span>
        </div>
        <div v-if="isview===true" style="margin:10px 0">
          <!--          <span style="color:#99a9bf;">审批图片：</span>-->
          <el-image
            v-for="iurl in imgSrcList"
            style="width: 60px; height: 60px;margin-right: 10px;"
            :src="iurl"
            :preview-src-list="imgSrcList"
          >
          </el-image>
        </div>
        <el-form-item v-if="isview===false" label="审批图片" prop="imgids">
          <MultiImg v-model="editForm.imgids" :size="'sm'"></MultiImg>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-popconfirm v-if="isview===false" :key="btnKey" title="确认处理此物料申请单吗？" placement="top" @onConfirm="subEdit('editForm')">
            <el-button slot="reference" type="primary" icon="el-icon-check" :loading="editloading">立即处理</el-button>
          </el-popconfirm>
          <el-button icon="el-icon-printer" :loading="printLoading" style="margin-left:10px" @click="print(editForm.maid)">打印物料申请单</el-button>
          <el-button v-if="isview===false" @click="editVisible=false">取消</el-button>
          <el-button v-if="isview===true" @click="editVisible=false">关闭</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="collectRecordTitle"
      :visible.sync="collectRecordDialog"
      width="800px"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <div style="height:40px">
        <span style="color:#99a9bf;">经销商：</span>
        <span>{{ editCollectForm.delname }}</span>
        <span style="color:#99a9bf;margin-left:30px">总价：</span>
        <span style="font-weight: 500;color:#409EFF">{{ editCollectForm.totalprice }}</span>
      </div>
      <el-table
        v-loading="collectRecordLoading"
        :data="collectRecord"
        border
        height="400"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          prop="receipttime"
          label="收款日期"
          align="center"
          width="120"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="type"
          label="收款类型"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.type===0">银行收款</span>
            <span v-if="scope.row.type===1">账户扣款</span>
            <!-- <span v-if="scope.row.type===2">微信</span> -->
            <!-- <span v-if="scope.row.type===3">售后赔款</span> -->
          </template>
        </el-table-column>
        <el-table-column
          label="收款金额"
          align="center"
          width="100"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span style="color:#409EFF;font-weight: 500;">{{ scope.row.money }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="card"
          align="center"
          label="卡号"
          width="160"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          min-width="150"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="operName"
          label="操作人"
          align="center"
          width="100"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getMaterialApplyDetail, getMaterialApplyList, treatMaterialApply, printMaterialsApply, materialsCollectRecord } from '@/api/work'
import MultiImg from '@/components/upload/MultiImg'
import { getLodop } from '@/common/Lodop/LodopFuncs'
import { getUserWorkRule } from '@/api/user'

export default {
  name: 'Wlsqcl',
  components: {
    MultiImg
  },
  data() {
    return {
      imgSrcList: [],
      fullscreenLoading: false,
      editTitle: '物料申请单',
      searchForm: {
        search: '',
        type: null
      },
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editVisible: false,
      infoLoading: false,
      materialList: [],
      multipleSelection: [],
      editForm: {
        maid: '',
        manum: '',
        addprice: 0,
        delinfo: '',
        isnewbus: 0,
        remark: '',
        operName: '',
        opertime: '',
        imgids: []
      },
      editRules: {
        // imgids: [{ required: true, message: '请上传物料申请单审批图片', trigger: 'change' }]
      },
      editloading: false,
      isview: false,
      btnKey: '',
      printLoading: false,
      collectRecordDialog: false,
      collectRecordLoading: false,
      collectRecord: [],
      collectRecordTitle: '',
      editCollectVisible: false,
      collectInfoLoading: false,
      editCollectForm: {
        delname: '',
        totalprice: 0
      },
      isMenu: 0
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
  },
  methods: {
    Search() {
      if (this.searchForm.search !== null && this.searchForm.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        oper: this.searchForm.type,
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        userid: this.user.dUserid,
        iscl: 1,
        groupid: this.user.dGroupid
      }
      getMaterialApplyList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    editApply(id) {
      this.imgSrcList = []
      this.editForm.isnewbus = 0
      this.materialList = []
      this.editForm.imgids = []
      this.editForm.maid = id
      this.editForm.remark = ''
      this.infoLoading = true
      this.btnKey = new Date().getTime()
      getMaterialApplyDetail({ applyid: this.editForm.maid, groupid: this.user.dGroupid }).then(response => {
        const datalist = []
        for (const m of response.data.materialList) {
          if (m.ischeck) {
            if (response.data.materialsApply.isnewbus === 1) {
              let count = m.counts
              if (m.is_standard === 1) {
                count = count - m.standard
                if (count < 0) {
                  count = 0
                }
              }
              m.addprice = (m.price * count).toFixed(2)
            } else {
              m.addprice = (m.price * m.counts).toFixed(2)
            }
            if (m.children && m.children.length > 0) {
              const children = []
              let reduce_count = 0
              m.children.forEach(child => {
                if (child.ischeck) {
                  if (response.data.materialsApply.isnewbus === 1) {
                    let count = child.counts
                    if (child.is_standard === 1) {
                      reduce_count += child.counts
                      count = reduce_count - m.standard
                      if (count < 0) count = 0
                      if (count > child.counts) count = child.counts
                    }
                    child.addprice = (child.price * count).toFixed(2)
                  } else {
                    child.addprice = (child.price * child.counts).toFixed(2)
                  }
                  children.push(child)
                } else {
                  child.addprice = 0
                }
              })
              m.children = children
            }
            datalist.push(m)
          }
        }
        this.materialList = datalist
        this.editForm.remark = response.data.materialsApply.remark
        this.editForm.isnewbus = response.data.materialsApply.isnewbus
        this.editForm.manum = response.data.materialsApply.manum
        this.editForm.addprice = response.data.materialsApply.addprice
        this.editForm.delinfo = response.data.materialsApply.delname
        this.editForm.operName = response.data.materialsApply.operName
        this.editForm.opertime = response.data.materialsApply.opertime
        const imgs = []
        for (const c of response.data.materialsApply.imgList) {
          imgs.push(c.imgUrl)
        }
        this.imgSrcList = imgs
        this.infoLoading = false
      }).catch(() => {
        this.infoLoading = false
      })
      this.editVisible = true
    },
    view(id) {
      this.isview = true
      this.editApply(id)
    },
    edit(id) {
      this.isview = false
      this.editApply(id)
    },
    subEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editloading) {
            for (const m of this.materialList) {
              if (m.instock < m.counts) {
                this.$message.error(m.material_name + ' 库存不足')
                return false
              }
            }
            this.editloading = true
            const data = {
              userid: this.user.dUserid,
              applyId: this.editForm.maid,
              imgIds: this.editForm.imgids.join(',')
            }
            treatMaterialApply(data).then(response => {
              this.$message({
                message: '物料申请处理成功',
                type: 'success'
              })
              this.editVisible = false
              this.editloading = false
              this.getData()
            }).catch(() => {
              this.editloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    print(id) {
      const LODOP = getLodop()
      if (LODOP !== null && LODOP !== undefined) {
        this.printLoading = true
        printMaterialsApply({ maid: id }).then(response => {
          LODOP.PRINT_INIT('物料申请单打印')
          LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4')
          LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Auto-Width')
          LODOP.ADD_PRINT_TABLE(30, '11mm', '100%', '100%', response.data)
          LODOP.SET_PRINT_STYLEA(0, 'HOrient', 3)
          LODOP.SET_PRINT_STYLEA(0, 'VOrient', 3)
          LODOP.SET_SHOW_MODE('LANDSCAPE_DEFROTATED', 1)
          LODOP.NewPageA()
          LODOP.SET_PRINT_STYLEA(0, 'HtmWaitMilSecs', 100)
          LODOP.PREVIEW()
          this.printLoading = false
        }).catch(() => {
          this.printLoading = false
        })
      }
    },
    getCollectRecord(row) {
      this.collectRecordTitle = '物料申请单 ' + row.apply_order + ' 收款详细'
      this.editCollectForm.delname = row.all_name
      this.editCollectForm.totalprice = row.addprice
      this.collectRecord = []
      this.collectRecordDialog = true
      this.collectRecordLoading = true
      materialsCollectRecord({ maid: row.apply_id }).then(response => {
        const list = []
        for (const d of response.data) {
          if (d.mark === 2) {
            list.push(d)
          }
        }
        this.collectRecord = list
        this.collectRecordLoading = false
      }).catch(() => {
        this.collectRecordLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wlsqcl-container {
  .el-table .el-table__footer-wrapper{
    color:#409EFF;
  }
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .add-btn{
            position: relative;
            float: right;
            margin-left: 10px;
            margin-top: -10px;
          }
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
